import React from "react";

import { StoryCard } from "../basic/story-card.js"
import { StoryList } from "../basic/story-list.js"
import { DfpAd } from "../dfp-ad";
import { SectionName } from "../basic/section-name.js";
import {collectionSection} from '../collection-templates/collection-layout-helper';

import { wrapCollectionLayout } from "@quintype/components";

function TwoColOneAdBase({collection, config, stories, associatedMetadata}) {
  const storyCardConfig = {
    section: true,
    subheadline: true,
    image: true
  }
  const storyListConfig = {
    section: true
  }
  const  {'show_collection_title': collectionName = true} = associatedMetadata;

    return (
    <div className ="component-wrapper">
    { collectionName ? <SectionName  name={collection.name} type="large" section={collectionSection(config, collection)}/> : null}
    <div className="two-col-one-ad">
      <div>
        <StoryCard
          story={stories[0]}
          config={storyCardConfig}>
        </StoryCard>
      </div>
      <div>
        <StoryList
          stories={stories.slice(1, 4)}
          config={storyListConfig}>
        </StoryList>
      </div>
      <div>
        <StoryList
          stories={[stories[4]]}
          config={storyListConfig}>
        </StoryList>
        <div className="app-ad app-ad--mrec">
          <DfpAd adtype="Mrec" layoutName="TwoColOneAd" collectionSlug={collection.slug}/>
        </div>
      </div>
    </div>
    </div>
  )

}

export const TwoColOneAd = wrapCollectionLayout(TwoColOneAdBase);
